import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './index.css';
import Dashboard from './components/Dashboard.jsx';
import Protected from './components/Protected.jsx';
import Dlog from './components/Dlog.jsx';
import ProfilePage from './components/ProfilePage.jsx';
import Messager from './components/Messager/Messages.jsx';
import PetSim from './components/PetSim/PetGame.jsx';
import Pet from './components/PetSim/Pet.jsx';
import Katie from './components/Katie/Katie.jsx';
import LianLianKan from './components/LianLianKan/LianLianKan.jsx';
import axios from 'axios';

axios.defaults.withCredentials = true;

// using createBrowserRouter to create an array of js objects(routes)
const router = createBrowserRouter([
  { path: '/', element: <Dashboard /> },
  { path: '/Dashboard', element: <Dashboard /> },
  { path: '/Dashboard/Dlog', element: <Protected><Dlog /></Protected> },
  { path: '/Dashboard/ProfilePage', element: <Protected><ProfilePage /></Protected> },
  { path: '/Dashboard/Messager', element: <Protected><Messager /></Protected> },
  { path: '/Dashboard/PetSim', element: <Protected><PetSim /></Protected> },
  { path: '/Dashboard/PetSim/Pet', element: <Protected><Pet /></Protected> },
  { path: '/Dashboard/Katie', element: <Protected><Katie /></Protected> },
  { path: '/Dashboard/LianLianKan', element: <Protected><LianLianKan /></Protected> },
]);


createRoot(document.getElementById('root')).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
